"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _LoadingBar = _interopRequireDefault(require("./LoadingBar"));

var _TrackingStep = _interopRequireDefault(require("./TrackingStep"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getActiveId = function getActiveId(active, stages) {
  return stages ? stages.findIndex(function (item) {
    return item.key === active;
  }) + 1 : 0;
};

var TrackingBar = function TrackingBar(_ref) {
  var active = _ref.active,
      background = _ref.background,
      filledColor = _ref.filledColor,
      height = _ref.height,
      stages = _ref.stages,
      className = _ref.className;
  var activeId = getActiveId(active, stages);
  return /*#__PURE__*/_react.default.createElement(StyledTrackingBar, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_LoadingBar.default, {
    stagesLength: stages.length,
    activeId: activeId,
    background: background,
    filledColor: filledColor,
    height: height
  }), stages.map(function (stage) {
    return /*#__PURE__*/_react.default.createElement(_TrackingStep.default, {
      key: stage.id,
      stage: stage,
      activeId: activeId
    });
  }));
};

var StyledTrackingBar = _styledComponents.default.div.withConfig({
  displayName: "StyledTrackingBar"
})(["display:flex;font-family:", ";justify-content:space-evenly;width:100%;align-items:center;margin:4vh auto 0.55vh;position:relative;@media (max-width:768px){margin:0;width:initial;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
});

TrackingBar.defaultProps = {
  active: 'data_analysis',
  background: '#D3D4D8',
  height: '2px',
  stages: []
};
TrackingBar.propTypes = {
  active: _propTypes.string,
  background: _propTypes.string,
  filledColor: _propTypes.string,
  stages: (0, _propTypes.arrayOf)(_propTypes.object),
  height: _propTypes.string,
  className: _propTypes.string
};
var _default = TrackingBar;
exports.default = _default;